import "../styles/ToastNotification.css";

export default function ToastNotification({ show, message, type = "success" }) {
  if (!show || !message) {
    return null;
  }

  return (
    <div className={`toast-notification toast-notification--${type}`} role="status">
      <div className="toast-notification__content">
        {type === "success" ? "✓" : "✗"} {message}
      </div>
    </div>
  );
}
